module.exports = __webpack_public_path__ + "static/media/results-sidebar-wave-image.152e4dcf.svg";